import { render, staticRenderFns } from "./CarouselItems.vue?vue&type=template&id=25d615e6&"
import script from "./CarouselItems.vue?vue&type=script&lang=js&"
export * from "./CarouselItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports